'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthHookContextPage = require('@narvar/nth-hook-context-page');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var nthHookLoma = require('@narvar/nth-hook-loma');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var graphql = require('../graphql.js');
var types = require('../types.js');

const useSubscribeNotificationPreferenceMutate = ({
  data: notificationPreferencesAndLevelData,
  options
}) => {
  const {
    state: pageContext
  } = nthHookContextPage.usePageContext();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const {
    globalSettings: {
      retailerLevelOptInEnabled,
      hipaaCompliant
    }
  } = nthHookGlobalSettings.useGlobalSettingsX();
  const {
    experienceHost,
    embedReferrerUrl,
    requestUrl,
    trackingNumbers,
    orderNumbers
  } = pageContext;
  const referrerUrl = experienceHost === 'EMBED' && embedReferrerUrl ? embedReferrerUrl : requestUrl ?? window?.location.href;
  const trackingNumber = (trackingNumbers && trackingNumbers[0]) ?? '';
  // in the context of messaging API, orderNumber is called orderId
  const orderId = (orderNumbers && orderNumbers[0]) ?? '';
  const notificationPreferences = notificationPreferencesAndLevelData?.getNotificationPreferencesAndLevel ?? undefined;
  const {
    preferenceLevel,
    modifiedDatetime = '',
    isActive,
    isGuest
  } = notificationPreferences ?? {};
  const [mutate, {
    loading
  }] = nthHookLoma.useUpdateNotificationPreferencesAllLevelsMutation({
    refetchQueries: [graphql.getNotificationPreferencesAndLevelQuery],
    awaitRefetchQueries: true,
    ...options
  });
  const onSubscribeMutate = (currentChannel, notificationPrefDetails, retailerLevelChecked = false, marketingOptInChecked = false) => {
    // log to catch possibly missing tracking number as observed in TRACK-144
    if ((preferenceLevel === 'TRACKING' || !preferenceLevel) && !trackingNumber) {
      logEvent({
        eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
        eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
        feature: 'Notification Center',
        orderNumber: orderId,
        pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
        pageOrderNumber: orderId,
        eventNotificationSmsValidationError: `no tracking number in tracking level sms mutation. trackingNumber in page context: ${trackingNumbers?.toString() || ''}`,
        eventType: nthHookContextAnalytics.NarvarEventTypes.ERROR
      });
    }
    mutate({
      variables: {
        ...pageContext,
        preferenceLevel: retailerLevelOptInEnabled && retailerLevelChecked && types.PreferenceLevels.RETAILER || preferenceLevel || types.PreferenceLevels.TRACKING,
        retailerMoniker: pageContext.retailerMoniker,
        trackingNumber,
        orderId,
        modifiedDatetime,
        isActive,
        isGuest,
        referrerUrl,
        hipaaCompliant,
        channel: currentChannel,
        notificationPrefDetails,
        marketingOptInChecked
      }
      // eslint-disable-next-line no-console
    }).catch(error => console.log(error));
  };
  return {
    onSubscribeMutate,
    loading
  };
};

exports.useSubscribeNotificationPreferenceMutate = useSubscribeNotificationPreferenceMutate;
